import React from 'react';
import './GalleryMedia.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const GalleryMedia = () => {
return( 
<div>
    <SideMenuBar></SideMenuBar>
    <div class="content">
        <NewHeader></NewHeader>
            
        <div className='row2'>
            <h3 className='gallery_GalleryMedia'>Gallery</h3>  
        </div>

        <div className='row3_GalleryMedia'>
            <div className='heading_GalleryMedia'>
                <a href='/GalleryMedia' className='a_of_heading_GalleryMedia'><p className='media_GalleryMedia'>&nbsp;Media&nbsp;</p></a>
                <a href='/GalleryDoc' className='a_of_heading_GalleryMedia'><p className='documents_GalleryMedia'>&nbsp;Documents&nbsp;</p></a>
            </div>
            <div className='subrow1_row3_GalleryMedia'>
                <a href='/'><img className='uploadPhoto_icon_GalleryMedia' src='../assets/gallery.png' alt='upload-icon'></img></a>
            </div>
    
            
        </div>

        
        

    </div>
</div>
 )
}

export default GalleryMedia;